<ng-template #modalConfirmacao let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      <i class="fa fa-question-circle"></i>
      Confirmação
    </h4>
    <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" aria-label="Fechar" (click)="modal.dismiss()">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="modal-body" [innerHtml]="message" data-testid="confirmation-message"></div>

  <div class="modal-footer">
    <button type="button" class="sf-btn sf-btn--ghost push" (click)="modal.close('NO')" data-testid="btn-modal-cancel-action">Não</button>
    <button type="button" class="sf-btn sf-btn--primary" (click)="modal.close('YES')" data-testid="btn-modal-confirm-action">Sim</button>
  </div>
</ng-template>
